<template>
  <ItemDialog ref="observationSeatWarning" image-type="alert">
    <template #content-area>
      <p class="text-center text-block">
        <span
          >展望席をご利用の場合は購入を選択してください。展望席は予約のみのお取り扱いはできません。</span
        >
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogObservationSeatWarning",
  props: {
    closeButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const observationSeatWarning = ref(null);

    const openDialog = () => {
      observationSeatWarning.value.open();
    };

    const closeDialog = () => {
      if (props.closeButtonClicked == null) {
        observationSeatWarning.value.close();
      } else {
        props.closeButtonClicked();
      }
    };

    return {
      observationSeatWarning,
      props,
      openDialog,
      closeDialog,
    };
  },
};
</script>

<style lang="scss" scoped>
.text-block {
  line-height: 21px;
}
</style>
